export default __webpack_public_path__ + "static/media/tex2res4.bc36379f.png";